import { DashboardTableRowActionItem, DashboardTableRowActions } from '@shigo-ui/dashboard-ui';
import { Copy, Edit3, Layers } from 'lucide-react';

import { dashboardT } from '../../../../../lib/messages';
import type { Campaign } from '../../model';

export function CampaignActions({
  campaign,
  pending,
  onEdit,
  onDuplicate,
}: {
  campaign: Campaign;
  pending: boolean;
  onEdit: () => void;
  onDuplicate: (deepCopyCreatives: boolean) => void;
}) {
  return (
    <DashboardTableRowActions
      label={dashboardT('campaigns.actionsFor', { name: campaign.name })}
      pending={pending}
      triggerClassName="h-8 w-8"
    >
      <DashboardTableRowActionItem onClick={onEdit}>
        <Edit3 className="h-4 w-4" aria-hidden="true" />
        {dashboardT('campaigns.edit')}
      </DashboardTableRowActionItem>
      <DashboardTableRowActionItem
        onClick={() => {
          onDuplicate(false);
        }}
      >
        <Copy className="h-4 w-4" aria-hidden="true" />
        {dashboardT('campaigns.duplicate')}
      </DashboardTableRowActionItem>
      <DashboardTableRowActionItem
        onClick={() => {
          onDuplicate(true);
        }}
      >
        <Layers className="h-4 w-4" aria-hidden="true" />
        {dashboardT('campaigns.deepDuplicate')}
      </DashboardTableRowActionItem>
    </DashboardTableRowActions>
  );
}
